import { read } from '@/api/rest';

const competence = {
  index: async (params) => await read('/competence?' + params.toString()),
  projectStats: async (params) =>
    await read('/competence/project-stats?' + params.toString()),
  briefcaseStats: async (params) =>
    await read('/competence/briefcase-stats?' + params.toString()),
};

export default competence;
